import { useEffect, useState } from 'react';

/**
 * This hook detects if the user has scrolled the page.
 * Similar to `useHasScrolled`, but this one only triggers w/ specific user interactions.
 * Useful for discriminating between user-initiated scrolls and programmatic/auto scrolls.
 */
export const useHasUserScrolled = (): boolean => {
  const [hasUserScrolled, setHasUserScrolled] = useState(false);

  useEffect(() => {
    const clearEventListeners = () => {
      window.removeEventListener('wheel', handleUserScroll);
      window.removeEventListener('touchmove', handleUserScroll);
      window.removeEventListener('keydown', handleUserScroll);
    };

    const handleUserScroll = () => {
      setHasUserScrolled(true);
      clearEventListeners();
    };

    window.addEventListener('wheel', handleUserScroll, { passive: true });
    window.addEventListener('touchmove', handleUserScroll, { passive: true });
    window.addEventListener('keydown', handleUserScroll);

    return () => clearEventListeners();
  }, []);

  return hasUserScrolled;
};
